import { createSelector } from 'reselect';
import MrdXmlAnalysisColumns from '../../containers/MrdXmlAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.MRD_XML_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.MRD_XML_ANALYSIS.isLoading;

export const getData = ReportDefinitions.MRD_XML_ANALYSIS.getDataFunction();

export const getColumns = createSelector(getData, MrdXmlAnalysisColumns);
